import { useEffect, useState } from "react";
import StatCard from "pages/dashboard-overview/components/StatCard";
import { fetchSalesSummary } from "services/salesService";

const formatCurrency = (value) =>
  Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const StatCardSkeleton = () => (
  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5">
    <div className="flex justify-between items-start">
      <div className="flex-1">
        <div className="h-4 w-28 bg-gray-200 animate-pulse rounded" />
        <div className="h-8 w-24 bg-gray-200 animate-pulse rounded mt-2" />
      </div>
      <div className="h-9 w-9 bg-gray-200 animate-pulse rounded-lg" />
    </div>
  </div>
);

export default function SalesSummaryCards({ api, filters, refreshKey = 0 }) {
  const [summary, setSummary] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const loadSummary = async () => {
      setIsLoading(true);
      try {
        const data = await fetchSalesSummary(api, { filters });
        if (!cancelled) setSummary(data);
      } catch {
        if (!cancelled) setSummary(null);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    loadSummary();
    return () => {
      cancelled = true;
    };
  }, [api, filters.dateRangeType, filters.customDateRange?.[0], filters.customDateRange?.[1], refreshKey]);

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {[...Array(4)].map((_, i) => (
          <StatCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  const netRevenue = summary?.netRevenue ?? 0;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <StatCard
        title="Total Sales Count"
        value={summary?.totalSales ?? 0}
        icon="ShoppingCart"
      />
      <StatCard
        title="Total Revenue"
        value={formatCurrency(summary?.totalRevenue ?? 0)}
        icon="DollarSign"
      />
      <StatCard
        title="Total Refund Amount"
        value={formatCurrency(summary?.totalRefundAmount ?? 0)}
        icon="RotateCcw"
      />
      <StatCard
        title="Net Revenue"
        value={formatCurrency(netRevenue)}
        icon={netRevenue >= 0 ? "TrendingUp" : "TrendingDown"}
      />
    </div>
  );
}
